module.exports = __webpack_public_path__ + "fonts/Inter-200-cyrillic-ext29.df55b7e.woff2";